import { useId } from 'react';
import { Box, Typography } from '@mui/material';

/** Donut chart for the overall flow-progress percentage — a gradient arc over
 * a soft track, with the percentage centered inside (mirrors the console-mock
 * "Flow progress" ring). */
export function FlowProgressRing({ percent, size = 136 }: { percent: number; size?: number }) {
  const gradientId = useId();
  const stroke = 13;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.min(100, Math.max(0, percent));
  const offset = circumference * (1 - clamped / 100);
  return (
    <Box sx={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: 'rotate(-90deg)' }}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="var(--color-primary)" />
            <stop offset="100%" stopColor="var(--color-accent-cyan)" />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="var(--color-primary-soft)" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.6s ease' }}
        />
      </svg>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography sx={{ fontWeight: 800, fontSize: 28, lineHeight: 1 }}>{clamped}%</Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', mt: 0.5 }}
        >
          VALIDATED
        </Typography>
      </Box>
    </Box>
  );
}
